var initSlider = function initSlider() {
  new Swiper('.topbar__slider', {
    slidesPerView: 1,
    autoplay: {
      delay: 2000
    },
    loop: true
  });
};
export { initSlider };